// extracted by mini-css-extract-plugin
export default {"item":"item--Ms_HD","riskTips":"riskTips--pYkZr","concatenatedKeywords":"concatenatedKeywords--bfxY6"};